export const SET_DIRTY = 'SET_DIRTY';
export const SET_DESTINATION = 'SET_DESTINATION';

export function setDirty(dirty: boolean) {
    return { type: SET_DIRTY, payload: dirty};
};
export function setDestination(destination: string) {
    console.log(destination)
    return { type: SET_DESTINATION, payload: destination};
};